// components/Footer.js
import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleHashClick = (e, targetHash) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById(targetHash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/#${targetHash}`);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <div className="footer-logo" onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }} style={{ cursor: 'pointer' }}>
            <img src={'/conveks_final_transparent_sq.png?v=2'} className={'logo'} alt="Conveks Logo" style={{ height: '100px', objectFit: 'contain' }} />
          </div>
          <p>{t('footer.tagline')}</p>
        </div>

        <div className="footer-column">
          <h3>{t('footer.quickLinks')}</h3>
          <ul className="footer-links">
            <li>
              <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{t('navbar.home')}</Link>
            </li>
            <li>
              <Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{t('navbar.about')}</Link>
            </li>
            <li>
              <Link to="/resources" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{t('navbar.resources')}</Link>
            </li>
            <li>
              <a href="#contact" onClick={(e) => handleHashClick(e, 'contact')}>{t('navbar.contact')}</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>{t('footer.solutionsHead')}</h3>
          <ul className="footer-links">
            <li>
              <Link to="/solutions/field-service-optimization" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('solutionsDropdown.fieldService')}
              </Link>
            </li>
            <li>
              <Link to="/solutions/operational-forecasting" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('solutionsDropdown.forecasting')}
              </Link>
            </li>
            <li>
              <Link to="/solutions/ops-analytics-anomaly-detection" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('solutionsDropdown.analytics')}
              </Link>
            </li>
            <li>
              <Link to="/solutions/knowledge-intelligence" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('solutionsDropdown.knowledge')}
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>{t('footer.contactHead')}</h3>
          <ul className="contact-list">
            <li>
              <span>📧</span>
              <a href="mailto:info@conveks.com">info@conveks.com</a>
            </li>
            <li>
              <span>📞</span>
              <a href="tel:+905445956696">+90 (544) 595-6696</a>
            </li>
            <li>
              <span>📍</span>
              <address style={{ display: 'inline', color: 'var(--text-secondary)', fontStyle: 'normal' }}>{t('footer.istanbulTurkey')}</address>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.rights', { year: new Date().getFullYear() })}</p>
        <div className="footer-legal">
          <a href="#privacy">{t('footer.privacy')}</a>
          <a href="#terms">{t('footer.terms')}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;